export const BUSINESS_ACCOUNT_BONUS_LIST = "BUSINESS_ACCOUNT_BONUS_LIST";
export const UPDATE_BUSINESS_ACCOUNT_BONUS_STATUS = "UPDATE_BUSINESS_ACCOUNT_BONUS_STATUS";